/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-27 16:21:49
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-04 11:20:31
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelCategory/PagesCategory/ContentCategory/index.tsx
 */
import React from 'react';
import Header from './Header';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCategoriesContent, getRootUuid } from './slice';
import { useParams } from 'react-router-dom';
import Root from './Root';
import groupGenerate from './CollapseGroupContainer';
//import { breadcrumbData } from 'src/pages/SalesChannelCategory/slice/common';
import { EnumReducers } from 'src/pages/SalesChannelCategory/slice/constants';

const CategoryContent = (props) => {
  const { userPermissions } = props;
  const _p: { uuid: string } = useParams();
  const { uuid } = _p;
  const _d = useDispatch();
  const rootUuid = useSelector(getRootUuid());

  React.useEffect(() => {
    _d(fetchCategoriesContent({ uuid }));
  }, []);

  const Child = () => {
    if (true) {
      return [
        {
          element: Header,
          id: 'ContentHeader',
          p: { uuid, target: EnumReducers.content },
        },
        ...(rootUuid
          ? [
              {
                element: Root,
                id: 'Root',
                p: { uuid: rootUuid, salesChannelUuid: uuid, userPermissions },
              },
            ]
          : []),
        ...groupGenerate({ salesChannelUuid: uuid, userPermissions }),
      ];
    } else {
      return [];
    }
  };
  const Ele = Child().map((i, index) => {
    const { id, p = {} } = i;
    return <i.element key={id || index} {...p} />;
  });
  return <React.Fragment>{Ele}</React.Fragment>;
};

export default CategoryContent;
